const browsers = {
  Safari: { version: 14, downloadUrl: 'https://support.apple.com/fr-fr/102665' },
  'Mobile Safari': { version: 14, downloadUrl: 'https://support.apple.com/fr-fr/102665' },
  Chrome: { version: 69, downloadUrl: 'https://www.google.com/intl/fr/chrome/' },
  Firefox: { version: 69, downloadUrl: 'https://www.mozilla.org/fr/firefox/' },
  Opera: { version: 56, downloadUrl: 'https://www.opera.com/fr/download' },
};

export default browsers;
